// extracted by mini-css-extract-plugin
export default {"brandsTitle":"index_brandsTitle_Csx0d","titleWrapper":"index_titleWrapper_kfoL4","title_logo":"index_title_logo_fKZu4","title":"index_title_l4wx4","linkList":"index_linkList_Ac0oo"};